<section class="top-header blue-bg d-flex">
  <div class="logo d-flex align-items-center">
    <i class="fad fa-users"></i>
    <span class="app-title text-white">
      Users & Rights Management
    </span>
  </div>
  <div class="top-menu ml-auto">
    <ul class="nav">
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
          <i class="fal fa-globe"></i>
          English
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" href="#">Spanish</a>
          <a class="dropdown-item" href="#">French</a>
        </div>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
          <i class="fal fa-user"></i>
          <span>Super Mario</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" href="#"><i class="fal fa-sign-out"></i>Logout</a>
        </div>
      </li>
    </ul>
  </div>
</section>
<section class="p-3">
  <div class="users-management-section">
    <div class="users-panel active">
      <div class="users-roles-panel-tabs">
        <ul>
          <li [ngClass]="{ 'active': currentUserPanelTab === 'users' }" (click)="switchPanelTab('users-panel', 'users')"><i class="fa fa-user"></i> Users</li>
          <li [ngClass]="{ 'active': currentUserPanelTab === 'roles' }" (click)="switchPanelTab('users-panel', 'roles')"><i class="fa fa-users"></i> Groups</li>
        </ul>
      </div>
      <div class="users-roles-panel-tabs-content">
        <div class="users panel-content" [hidden]="currentUserPanelTab === 'roles'">
          <div class="filters" [ngClass]="{ 'cas-search-active': userCASImportActive }">
            <label class="panel-filter-label" for="users-panel-filter"><i class="fa fa-search"></i></label>
            <input type="text" class="filter-input" *ngIf="!userCASImportActive" id="users-panel-filter" placeholder="Filter local users" />
            <input type="text" class="filter-input" *ngIf="userCASImportActive" id="users-panel-filter" placeholder="Search in CAS users" />
            <button class="import-user-cas-btn" (click)="toggleUserCASImport()"><i class="fa fa-user-plus"></i></button>
          </div>
          <div class="panel-list">
            <ul [hidden]="userCASImportActive">
              <li *ngFor="let user of usersList; let index = index;" [ngClass]="{ 'active': activeUser?.id === user.id }">
                <span (click)="selectUser(user)">{{ user.name }} {{ user.lastName }}</span>
                <i class="fa fa-info-circle" (click)="userInfo(user)"></i>
              </li>
            </ul>
          </div>
        </div>
        <div class="roles panel-content" [hidden]="currentUserPanelTab === 'users'">
          <div class="filters">
            <label class="panel-filter-label" for="roles-panel-filter"><i class="fa fa-search"></i></label>
            <input type="text" class="filter-input" id="roles-panel-filter" placeholder="Filter groups" />
          </div>
          <div class="panel-list">
            <ul>
              <li *ngFor="let group of groupsList; let index = index;" [ngClass]="{ 'active': activeGroup?.id === group.id, 'has-unit': group.unit !== undefined }">
                <span (click)="selectGroup(group)">{{ group.name }}{{ group.unit !== undefined ? ' - ' + group.unit : '' }}</span>
                <i class="fa fa-info-circle" (click)="groupInfo(group)"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-container" [ngClass]="{ 'active': userInfoActive && userIsActive || groupIsActive && groupInfoActive }">
      <div class="inner">
        <i class="fa fa-times close-detail" (click)="userInfoActive = false"></i>
        <div class="user-detail" *ngIf="userInfoActive">
          <h3>Information from CAS</h3>
          <div class="d-flex">
            <div class="flex-auto form-field input">
              <label for="first-name">First name</label>
              <input id="first-name" type="text" value="Name" />
            </div>
            <div class="flex-auto form-field input">
              <label for="first-name">Last name</label>
              <input id="first-name" type="text" value="Last Name" />
            </div>
          </div>
          <div class="d-flex">
            <div class="form-field input">
              <label for="email">Email</label>
              <input type="text" id="email" value="somename@someserver.com" />
            </div>
          </div>
        </div>
        <div class="group-detail" *ngIf="groupInfoActive">
          <h3>Group information</h3>
          <div class="d-flex">
            <div class="form-field input">
              <label for="email">Name</label>
              <input type="text" id="group-name" value="{{ activeGroup.name }}" />
            </div>
            <div *ngIf="activeGroup.unit !== undefined" class="form-field input">
              <label for="email">Unit</label>
              <input type="text" id="group-name" value="{{ activeGroup.unit }}" />
            </div>
          </div>
          <div class="d-flex mt-1 align-items-center">
            <h4>Users in this group</h4>
            <i class="far fa-plus ml-auto plus-icon"></i>
          </div>
          <div class="users-in-group">
            <ol>
              <li *ngFor="let user of activeGroup.users"><span (click)="userInfo(user)">{{ user.name }} {{ user.lastName }}</span> <i class="far fa-times ml-auto"></i></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="users-rights-main-area">
      <div class="d-flex users-global-filter-container" [hidden]="currentContentPanelTab === 'rights'">
        <select name="users-filter" id="users-global-filter">
          <option value="">All</option>
          <option value="">Business</option>
          <option value="">Part B Operator</option>
          <option value="">Chat advisors</option>
        </select>
      </div>
      <div class="users-rights-tabs">
        <ul>
          <li [ngClass]="{ 'active': currentContentPanelTab === 'users' }" (click)="switchPanelTab('content-panel', 'users')">Details</li>
          <li [ngClass]="{ 'active': currentContentPanelTab === 'rights' }" (click)="switchPanelTab('content-panel', 'rights')">Rights</li>
        </ul>
      </div>
      <div class="users-rights-tabs-content">
        <div class="users-tab" [hidden]="currentContentPanelTab !== 'users'">
          <table class="tab-table">
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Birthday</th>
                <th>City</th>
                <th>Area</th>
                <th>Sector</th>
                <th>Activity</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of usersList; let index = index;" [hidden]="userIsActive && activeUser.id !== user.id">
                <td>{{ user.name }}</td>
                <td>{{ user.lastName }}</td>
                <td>{{ user.birthday }}</td>
                <td>{{ user.city }}</td>
                <td>Some area</td>
                <td>Some sector</td>
                <td>Some activity</td>
                <td class="row-options">
                  <span (click)="selectUser({id: user.id})"><i class="fa fa-cog"></i></span>
                  <span (click)="userInfo({id: user.id})"><i class="fa fa-pencil"></i></span>
                  <span class="red-color"><i class="fa fa-trash"></i></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="rights-tab" [hidden]="currentContentPanelTab !== 'rights'">
          <div class="p-1">
            <div class="d-flex mb-3">
              <div class="flex-one">
                <div class="d-flex align-items-center">
                  <h4 class="section-title">Services</h4>
                  <span class="section-add" (click)="serviceDrawerOpen = true"><i class="fa fa-plus-circle"></i></span>
                </div>
                <div class="selected-services-list">
                  <div class="service-item">
                    <span>Business Licence</span>
                    <i class="far fa-times"></i>
                  </div>
                  <div class="service-item">
                    <span>Tour Operator</span>
                    <i class="far fa-times"></i>
                  </div>
                </div>
              </div>
              <div class="flex-one">
                <div class="d-flex align-items-center">
                  <h4 class="section-title">Business Entity</h4>
                  <span class="section-add" (click)="serviceDrawerOpen = true"><i class="fa fa-plus-circle"></i></span>
                </div>
                <div class="selected-services-list">
                  <div class="service-item">
                    <span>Bhutan Tours Ltd</span>
                    <i class="far fa-times"></i>
                  </div>
                  <div class="service-item">
                    <span>Tashi Dorji</span>
                    <i class="far fa-times"></i>
                  </div>
                </div>
              </div>
              <div class="flex-one">
                <div class="d-flex align-items-center">
                  <h4 class="section-title">Groups</h4>
                  <span class="section-add" (click)="serviceDrawerOpen = true"><i class="fa fa-plus-circle"></i></span>
                </div>
                <div class="selected-services-list">
                  <div class="service-item">
                    <span>Some Role</span>
                    <i class="far fa-times"></i>
                  </div>
                  <div class="service-item">
                    <span>Some Group</span>
                    <i class="far fa-times"></i>
                  </div>
                </div>
              </div>
              <div>
                <button class="save-as-role ml-auto" (click)="roleNameSave = true"><i class="fas fa-save"></i> Save as group</button>
              </div>
            </div>
            <div class="permissions-table">
              <div class="heading-columns">
                <div></div>
                <div><span>View</span></div>
                <div><span>Edit</span></div>
                <div><span>Create</span></div>
                <div><span>Delete</span></div>
                <div><span>Transfer rights</span></div>
              </div>
              <div class="permissions-columns">
                <div class="all-rows">
                  <div class="permission-row">
                    <div>Part A</div>
                    <div><i class="fa fa-toggle-on on"></i></div>
                    <div><i class="fa fa-toggle-off"></i></div>
                    <div><i class="fa fa-toggle-on on"></i></div>
                    <div><i class="fa fa-toggle-on on"></i></div>
                    <div><i class="fa fa-toggle-off"></i></div>
                  </div>
                </div>
                <div class="permission-row">
                  <div>Application file</div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                </div>
              </div>
            </div>
            <div class="permissions-table">
              <div class="heading-columns">
                <div></div>
                <div><span>View</span></div>
                <div><span>Edit</span></div>
                <div><span>Create</span></div>
                <div><span>Delete</span></div>
                <div><span>Transfer rights</span></div>
              </div>
              <div class="permissions-columns">
                <div class="all-rows">
                  <div class="permission-row">
                    <div>Part B Roles</div>
                    <div><i class="fa fa-toggle-on on"></i></div>
                    <div><i class="fa fa-toggle-off"></i></div>
                    <div><i class="fa fa-toggle-on on"></i></div>
                    <div><i class="fa fa-toggle-on on"></i></div>
                    <div><i class="fa fa-toggle-off"></i></div>
                  </div>
                </div>
                <div class="permission-row">
                  <div>Tcb clearance</div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                </div>
                <div class="permission-row">
                  <div>Bl revision</div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                </div>
                <div class="permission-row">
                  <div>Business license approval</div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                </div>
                <div class="permission-row">
                  <div>Applicant requests office assessment</div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                </div>
                <div class="permission-row">
                  <div>Inspection</div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                </div>
                <div class="permission-row">
                  <div>Update tcb db with bl number</div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-on on"></i></div>
                  <div><i class="fa fa-toggle-off"></i></div>
                </div>
              </div>
            </div>
          </div>
          <div class="save-role-overlay" [ngClass]="{ 'active': roleNameSave }">
            <div class="save-role-modal">
              <input type="text" class="role-name-input" placeholder="Insert a name for the role" />
              <div class="d-flex">
                <button class="save ml-auto" (click)="roleNameSave = false">Save</button>
                <button class="cancel" (click)="roleNameSave = false">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="services-drawer" [ngClass]="{ 'active': serviceDrawerOpen }">
    <span class="drawer-close" (click)="serviceDrawerOpen = false"><i class="fa fa-times"></i></span>
    <div class="inner">
      <h4 class="section-title">Services</h4>
    </div>
    <div class="p-1">
      <table class="services-table">
        <thead>
          <tr>
            <th>Service Name</th>
            <th>Business Entity</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Service Name</td>
            <td>Business Entity</td>
            <td class="text-right icon-col"><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>Service Name</td>
            <td>Business Entity</td>
            <td class="text-right icon-col"><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>Service Name</td>
            <td>Business Entity</td>
            <td class="text-right icon-col"><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>Service Name</td>
            <td>Business Entity</td>
            <td class="text-right icon-col"><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>Service Name</td>
            <td>Business Entity</td>
            <td class="text-right icon-col"><i class="fa fa-check"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="service-drawer-overlay" [ngClass]="{ 'active': serviceDrawerOpen }" (click)="serviceDrawerOpen = false"></div>
</section>